import ActionMenu from "../../../../components/ui/materialui/actionMenu";
import { RowGeneracionSII } from "../models/rowGeneracionSII";
import { WorkspacePremium } from "@mui/icons-material";

interface IProps {
  filaSii: RowGeneracionSII;
  generarCertificadoIndividual: (e: number) => void
}

const AccionesSII: React.FC<IProps> = ({ filaSii, generarCertificadoIndividual }) => {

    const actions = [
        { label: "Generar certificado SII", icon: <WorkspacePremium fontSize="small" />, onClick: () => {generarCertificadoIndividual(filaSii.mutuoId)} },
    ];

    return (
        <>
            <ActionMenu actions={actions} />
        </>
    );
}

export default AccionesSII;